<template>
    <h5 class="footer-title" style="float:left;">Subscribe Newsletter</h5>
    <div class="clear"></div>
    <div class="update-form">


        <Form autocomplete="off" @submit="onSubmit" :validation-schema="schema" v-slot="{errors}" class="bg-body">
            <div class="d-flex">
                <span><i class="feather-mail"></i></span>

                <Field type="text" name="emailname" v-model="emailValuecomp.EmailValue"
                       :class="{ 'form-control' : true ,'is-invalid': errors.emailname }"
                       :placeholder="$t('StoreFront.EnterEmail')" />

                <button type="submit" class="btn btn-subscribe"><span><i class="feather-send"></i></span></button>
            </div>
            <div class="invalid-feedback">{{errors.emailname}}</div>
        </Form>

    </div>


</template>
<script>
    import { Form, Field } from 'vee-validate';
    export default {
        components: {
            Form, Field
        },
        props: ['schema','emailValuecomp'],
        emits: ["submitNewsLetter"],
        data() {
            return {
                showForm: true
            }
        },
        methods: {
            onSubmit() {
                this.$emit("submitNewsLetter", this.emailValuecomp.EmailValue);
            }
        }
    }
</script>